import './index.css';

import { useEffect, useState } from 'react';
import { GrowthBookProvider } from '@growthbook/growthbook-react';
import * as Sentry from '@sentry/react';
import { Integrations } from '@sentry/tracing';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { MotionGlobalConfig } from 'framer-motion';
import 'moment-timezone';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { unstable_HistoryRouter as HistoryRouter } from 'react-router';
import browserHistory from './history';
const homePath = process.env.PUBLIC_URL;

import App from './App';
import './services/runSagas';
import { store } from './store/configureStore';

import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { growthbook } from './growthbook';
import { CustomSpinner } from './commonComponents';

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_KEY);

export const queryClient = new QueryClient();

MotionGlobalConfig.skipAnimations = process.env.REACT_APP_TEMP_MEE_ENV === 'test';

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_KEY,
  autoSessionTracking: true,
  integrations: [new Integrations.BrowserTracing()],
  environment: process.env.REACT_APP_TEMP_MEE_ENV,
  tracesSampleRate: 1.0,
});

const Root = () => {
  const [isReady, setIsReady] = useState(false);

  const init = async () => {
    try {
      await growthbook.init();
    } catch (error) {
      console.error(`App Init Failed: ${error?.message}`);
    }
    setIsReady(true);
  };

  useEffect(() => {
    init();
  }, []);

  if (!isReady) {
    return <CustomSpinner isLoading />;
  }

  return (
    <GrowthBookProvider growthbook={growthbook}>
      <Provider store={store}>
        <QueryClientProvider client={queryClient}>
          <Elements stripe={stripePromise}>
            <HistoryRouter basename={homePath} history={browserHistory}>
              <App />
            </HistoryRouter>
          </Elements>
        </QueryClientProvider>
      </Provider>
    </GrowthBookProvider>
  );
};

// Get the root element
const container = document.getElementById('root');

// Create a root
const root = createRoot(container);
root.render(<Root />);
